const __LEH_firstclick = false;
const __LEH_hostname = 'skinception.com';

const __LEH_path = window.location.pathname + window.location.search;
const __LEH_redir_pattern = '^/ct/(\\d+)(?:\\?(.*))?$';
let __LEH_redir_regex = new RegExp('^' + __LEH_redir_pattern.replace(/\$([0-9]+)/g, '([^/]+)') + '/?$', 'i');
let __LEH_redir_match = __LEH_path.match(__LEH_redir_regex);
if (__LEH_redir_match) {
  let __LEH_redir_target = "/?u=$1";
  __LEH_redir_target = __LEH_redir_target.replace(/\$(\d+)/g, (_, groupIndex) => __LEH_redir_match[parseInt(groupIndex)]);
  if (window.location.search) {
    let _LEH_redir_target_qs = window.location.search;
    __LEH_redir_target += '&'+_LEH_redir_target_qs.substring(1);
  }
  window.location.replace(__LEH_redir_target);
}
let __LEH_oldCookie = {};
let __LEH_clickObj = { 'u': null, 'cd': null };
let __LEH_newClick = false;
try { __LEH_oldCookie = JSON.parse(__LEH_getCookie('leh_sh')); } catch(e) {}
if (__LEH_oldCookie && (__LEH_oldCookie.u || __LEH_oldCookie.cd)) { __LEH_clickObj = __LEH_oldCookie; }
const __LEH_urlParams = new URLSearchParams(window.location.search);
let __LEH_shop = window.location.href.match(/\?(\d+)/);
if (__LEH_shop && __LEH_shop[1]) { __LEH_clickObj.u = __LEH_shop[1]; }
if (__LEH_urlParams && __LEH_urlParams.size > 0) {
  if (!__LEH_firstclick) {
    if (__LEH_urlParams.get('u')) { __LEH_clickObj.u = __LEH_urlParams.get('u'); __LEH_newClick=true; }
    if (__LEH_urlParams.get('t')) {
      __LEH_clickObj.t1 = __LEH_urlParams.get('t');  
    } else {
      __LEH_clickObj.t1 = __LEH_urlParams.get('t1');
    }
    __LEH_clickObj.t2 = __LEH_urlParams.get('t2');
    __LEH_clickObj.t3 = __LEH_urlParams.get('t3');
    __LEH_clickObj.t4 = __LEH_urlParams.get('t4');
    __LEH_clickObj.t5 = __LEH_urlParams.get('t5');
    __LEH_clickObj.acv = __LEH_urlParams.get('acv');
    __LEH_clickObj.src = __LEH_urlParams.get('src');
    __LEH_clickObj.r = __LEH_urlParams.get('r');
    __LEH_clickObj.ref = document.referrer;
    __LEH_clickObj.host = __LEH_hostname;
    __LEH_clickObj.is_unique = true;
  }
  if (__LEH_urlParams.get('cd')) { __LEH_clickObj.cd = __LEH_urlParams.get('cd'); }
  if (__LEH_clickObj.u || __LEH_clickObj.cd) { 
    if (__LEH_clickObj.u && __LEH_oldCookie && __LEH_oldCookie.u && __LEH_oldCookie.u == __LEH_clickObj.u) { __LEH_clickObj.is_unique=false; }
    __LEH_setCookie('leh_sh',JSON.stringify(__LEH_clickObj),1825);
    __LEH_storeNote(__LEH_clickObj);
    if (__LEH_newClick && __LEH_urlParams.get('nc') != 1) { __LEH_clickthrough(__LEH_clickObj); }
  }
} else if (__LEH_oldCookie && __LEH_oldCookie.u) { 
  __LEH_checkNote(__LEH_oldCookie); 
}
function __LEH_clickthrough(obj) {
  fetch('https://a.sllhlth.com/a/c', {
    method: 'POST',
    headers: {'Content-Type': 'application/json','Accept': 'application/json'},
    body: JSON.stringify(obj)
  })
  .then(response => response.json())
  .then((data) => {
    if (data['message'] && data['message'] == 'banned') {
      window.location.replace('https://www.sellhealth.com/banneduser.php');
    } else if (data['r']) {
      window.location.replace('https://'+data['r']);
    } else {
      console.log('SH Click Recorded: '+data['message'])
    }
  });  
}
function __LEH_storeNote(obj) {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({ note: JSON.stringify(obj) })
  })
  .then(response => response.json());  
}
function __LEH_checkNote(obj) {
  fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
  .then(response => response.json())
  .then(data => { 
    let p = {};
    try { p = JSON.parse(data.note); } catch (e) {}
    if (obj.u && !p.u) {
      obj.cd = null;
      __LEH_storeNote(obj);
      __LEH_setCookie('leh_sh',JSON.stringify(__LEH_clickObj),1825);
    }
  });  
}
function __LEH_showCartNotes() { fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' }).then(response => response.json()).then(data => { let p = {}; try { p = JSON.parse(data.note); } catch (e) {} console.log(p); }); }
function __LEH_showAllCart() { fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' }).then(response => response.json()).then(data => console.log(data)); }
function __LEH_clearCartNotes() { __LEH_storeNote(''); console.log('cleared'); }
function __LEH_setCookie(e,t,i){var n="";if(i){var r=new Date;r.setTime(r.getTime()+864e5*i),n="; expires="+r.toUTCString()}document.cookie=e+"="+(t||"")+n+"; path=/"}
function __LEH_getCookie(e){for(var t=e+"=",i=document.cookie.split(";"),n=0;n<i.length;n++){for(var r=i[n];" "==r.charAt(0);)r=r.substring(1,r.length);if(0==r.indexOf(t))return r.substring(t.length,r.length)}return null}
function __LEH_TimerCheck(s,e) {
  let isok = true;
  if (!s) { s = '2025-01-01 00:00:00'; }
  if (!e) { s = '2099-01-01 00:00:00'; }
  const d = new Date(new Date().toLocaleString("en-US", {timeZone: "America/Los_Angeles"}));
  const date = d.toISOString().split('T')[0];
  const time = d.toTimeString().split(' ')[0];
  const tnow = parseInt((date+' '+time).replace(/\D/g,""));
  const tactive = parseInt(s.replace(/\D/g,""));
  const tdeactive = parseInt(e.replace(/\D/g,""));
  if (tnow < tactive || tnow > tdeactive) { isok = false; }
  console.log ('TimerCheck ['+tnow+']: '+s+' --> '+e+' == '+isok);
  return isok;
}